var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50597 31.6596C8.21806 31.6596 7.93248 31.5995 7.675 31.4707C5.5873 30.4263 3.81712 28.837 2.55414 26.8674C1.21243 24.7751 0.49949 22.3416 0.5 19.856V14.7739C0.5 13.6694 1.39543 12.7739 2.5 12.7739H24.4678C25.5723 12.7739 26.4678 13.6694 26.4678 14.7739V19.856C26.4683 22.3416 25.7553 24.7751 24.4136 26.8674C23.1506 28.837 21.3805 30.4263 19.2928 31.4707C19.0353 31.5995 18.7497 31.6596 18.4618 31.6596H8.50597Z",
    fill: "#4C4577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1953 11.457V14.7739",
    stroke: "#F8F5FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1953 11.457V14.7739",
    stroke: "#F8F5FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1953 11.457V14.7739",
    stroke: "#F8F5FE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_42_15649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 26.7739V26.7739V20.8364H31.1328V26.7739C31.1332 28.8678 30.5327 30.9177 29.4024 32.6802C28.2746 34.439 26.6668 35.8378 24.7691 36.7114H15.6215C13.7238 35.8378 12.116 34.439 10.9882 32.6802C9.85796 30.9177 9.25738 28.8678 9.25781 26.7739Z",
    fill: "#E3D7FB",
    stroke: "#CCB7F8",
    strokeWidth: 0.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6078 36.7741C13.6939 35.8959 12.0723 34.4868 10.9356 32.7142C9.79889 30.9416 9.19488 28.8799 9.19531 26.7741L12.2577 27.5346C15.1794 28.2601 18.2509 28.1007 21.0818 27.0768C23.5091 26.199 26.12 25.9543 28.668 26.3659L31.1953 26.7741C31.1957 28.8799 30.5917 30.9416 29.455 32.7142C28.3183 34.4868 26.6967 35.8959 24.7828 36.7741H15.6078Z",
    fill: "#B292F4",
    stroke: "#CCB7F8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19531 36.7739H31.1953",
    stroke: "#CCB7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6078 36.7739C13.6939 35.8957 12.0723 34.4866 10.9356 32.714C9.79889 30.9414 9.19488 28.8797 9.19531 26.7739V20.7739H31.1953V26.7739C31.1957 28.8797 30.5917 30.9414 29.455 32.714C28.3183 34.4866 26.6967 35.8957 24.7828 36.7739",
    stroke: "#CCB7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1945 20.7739C32.2554 20.7739 33.2728 21.1954 34.023 21.9455C34.7731 22.6956 35.1945 23.7131 35.1945 24.7739V25.7739C35.1945 26.8348 34.7731 27.8522 34.023 28.6024C33.2728 29.3525 32.2554 29.7739 31.1945 29.7739H30.7695",
    stroke: "#CCB7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_42_15649",
    x: 1.19531,
    y: 19.7739,
    width: 41.9993,
    height: 35.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_42_15649"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_42_15649"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_42_15649",
    result: "effect2_dropShadow_42_15649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_42_15649",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepayIcon);
export default __webpack_public_path__ + "static/media/repay-icon.1ab6b9c0c6da0da265b28b47df998c61.svg";
export { ForwardRef as ReactComponent };